import React from 'react';
import { Form, Field, Button, TextInput } from 'shared';
import { TextAreaInput } from 'v1/components/shared';
import useModal from 'hooks/useModal';
import Modal from 'modals/layout';
import {
  configureIntegration,
  selectIntegrationById
} from 'store/integrations';
import { unwrapResult } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { IntegrationID } from '__types__';

const ConfigureDocuSignModal = () => {
  const dispatch = useDispatch();
  const { cancelModal } = useModal();
  const integration = useSelector(state =>
    selectIntegrationById(state, IntegrationID.DOCUSIGN)
  );
  const initialValues = {
    basePath: '',
    oAuthBasePath: '',
    integrationKey: '',
    userId: '',
    accountId: '',
    templateId: '',
    templateRoleName: '',
    rsaPrivateKey: '',
    ...integration?.configuration
  };

  const handleSubmit = data => {
    const basePath = data.basePath
      ? data.basePath
      : 'https://demo.docusign.net/restapi';

    const oAuthBasePath = data.oAuthBasePath
      ? data.oAuthBasePath
      : 'https://account-d.docusign.com';

    const URL = [
      `${oAuthBasePath}/oauth/auth?response_type=code`,
      `scope=impersonation,signature`,
      `client_id=${data.integrationKey}`,
      `redirect_uri=${encodeURI(`${window.location.origin}/docusign_callback`)}`
    ];

    // Create the docusign configuration. It must be disabled until the
    // docusign callback occurs so that access is granted to the scopes.
    const configuration = {
      ...data,
      basePath,
      oAuthBasePath
    };
    dispatch(
      configureIntegration({
        id: IntegrationID.DOCUSIGN,
        enabled: integration ? integration.enabled : false,
        configuration
      })
    )
      .then(unwrapResult)
      .then(_ => {
        window.location.href = URL.join('&');
      });
  };

  return (
    <Form values={initialValues} onSubmit={handleSubmit}>
      <Modal size="m">
        <Modal.Header title="Configure DocuSign integration" />
        <Modal.Content>
          <Modal.Scrollable>
            <div className="stack-s">
              <Field label="Integration Key" name="integrationKey" isRequired>
                <TextInput placeholder="DocuSign integration key" />
              </Field>
            </div>
            <div className="stack-s">
              <Field label="User ID" name="userId" isRequired>
                <TextInput placeholder="DocuSign user ID" />
              </Field>
            </div>
            <div className="stack-s">
              <Field label="Account ID" name="accountId" isRequired>
                <TextInput placeholder="DocuSign account ID" />
              </Field>
            </div>
            <div className="stack-s">
              <Field label="Template ID" name="templateId" isRequired>
                <TextInput placeholder="Envelope template ID" />
              </Field>
            </div>
            <div className="stack-s">
              <Field label="Template Role" name="templateRoleName" isRequired>
                <TextInput placeholder="Envelope template role name" />
              </Field>
            </div>
            <div className="stack-s">
              <Field label="RSA Private Key" name="rsaPrivateKey">
                <TextAreaInput placeholder="Service Integration RSA private key" />
              </Field>
            </div>
            <div className="stack-s">
              <Field label="API Base Path" name="basePath">
                <TextInput placeholder="Default: https://demo.docusign.net/restapi" />
              </Field>
            </div>
            <div className="stack-s">
              <Field label="Auth Base Path" name="oAuthBasePath">
                <TextInput placeholder="Default: https://account-d.docusign.com" />
              </Field>
            </div>
          </Modal.Scrollable>
          <Modal.Toolbar>
            <Button label="Cancel" action={cancelModal} />
            <Button
              label="Grant Access"
              icon="tick"
              appearance="primary"
              hasMarginLeft
              isLoading={false}
              action="submit"
            />
          </Modal.Toolbar>
        </Modal.Content>
      </Modal>
    </Form>
  );
};

export default ConfigureDocuSignModal;
